<template>
    <v-row>
        <v-icon-btn color="primary" @click="$emit('edit', item)">
            <v-icon>$pencil</v-icon>
        </v-icon-btn>
        <v-icon-btn color="primary" @click="$emit('delete', item)">
            <v-icon>$trash-can-outline</v-icon>
        </v-icon-btn>
    </v-row>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ModelActions",

    props: {
        item: {
            type: Object,
            required: true,
        },
    },

    computed: {},

    data() {
        return {};
    },
});
</script>
